import { render, staticRenderFns } from "./IngresosCactualcinPage.vue?vue&type=template&id=1f864eb8"
import script from "./IngresosCactualcinPage.js?vue&type=script&lang=js&external"
export * from "./IngresosCactualcinPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports